type PRODUCT_COUNT_BUCKETS =
  | '0to499' // Roughly the 25th percentile.
  | '500to1499' // Roughly the 50th percentile.
  | '1500to4999' // Roughly the 75th percentile.
  | '5000to19999'
  | '20000to39999'
  | 'gte40000' // The 100th percentile is 57K products.

export const getProductCountBucket = (
  productCount: number
): PRODUCT_COUNT_BUCKETS => {
  if (productCount <= 499) {
    return '0to499'
  }
  if (productCount <= 1499) {
    return '500to1499'
  }
  if (productCount <= 4999) {
    return '1500to4999'
  }
  if (productCount <= 19999) {
    return '5000to19999'
  }
  if (productCount <= 39999) {
    return '20000to39999'
  }
  return 'gte40000'
}

type RETAILER_GROUP = 'sufferers' | 'indifferent'

export const getRetailerGroupForSyncMetrics = (
  retailer_id: string
): RETAILER_GROUP | null => {
  if (
    retailer_id === '06f2e29c-25cb-11ee-ea12-baedf6f20cdb' || // dukaneebeautysupply
    retailer_id === '067f7b40-1e4d-11ed-e36a-de4496a54fae' || // oscarhunt1
    retailer_id === '0adfd74a-1555-11e9-fa42-5404c92efb69' // warehousesaleshoes
  ) {
    return 'sufferers'
  }

  if (
    retailer_id === '06819b3a-2e91-11ec-fa85-227a88520be9' || // jollyes
    retailer_id === '0a7cdf41-c76c-11ea-f4ff-f7ad30c0fa86' || // shosha
    retailer_id === '06326976-9d65-11ed-fa40-00c8fdf182b2' // 4wdsc
  ) {
    return 'indifferent'
  }

  return null
}
